import React, { useEffect, useState } from 'react';
import { Moon } from '@phosphor-icons/react';

/**
 * Muestra un aviso ámbar cuando la hora local de Argentina (America/Argentina/Buenos_Aires)
 * está entre 00:00 y 08:00. Se oculta automáticamente al llegar a las 08:00.
 *
 * Se re-evalúa cada minuto para no requerir reload.
 */
const getArgentinaHour = () => {
  try {
    // Intl con timeZone es la forma correcta de obtener la hora local de Argentina
    // sin importar la zona horaria del navegador del usuario.
    const parts = new Intl.DateTimeFormat('es-AR', {
      timeZone: 'America/Argentina/Buenos_Aires',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).formatToParts(new Date());
    const hh = parseInt(parts.find((p) => p.type === 'hour')?.value || '0', 10);
    const mm = parseInt(parts.find((p) => p.type === 'minute')?.value || '0', 10);
    return { hour: hh, minute: mm };
  } catch (e) {
    const d = new Date();
    // fallback: hora local
    return { hour: d.getHours(), minute: d.getMinutes() };
  }
};

const isNightHours = ({ hour }) => hour >= 0 && hour < 8;

export const NightScheduleWarning = ({ variant = 'default' }) => {
  const [visible, setVisible] = useState(() => isNightHours(getArgentinaHour()));

  useEffect(() => {
    const check = () => setVisible(isNightHours(getArgentinaHour()));
    check();
    // re-check every minute so it disappears automatically at 08:00 sin reload
    const id = setInterval(check, 60 * 1000);
    return () => clearInterval(id);
  }, []);

  if (!visible) return null;

  const compact = variant === 'compact';

  return (
    <div
      className={`flex items-start gap-3 rounded-xl border border-amber-500/40 bg-amber-500/10 ${
        compact ? 'p-3' : 'p-4'
      }`}
      data-testid="night-schedule-warning"
      role="status"
    >
      <div className="shrink-0 mt-0.5">
        <div className="w-9 h-9 rounded-full bg-amber-500/20 flex items-center justify-center">
          <Moon size={20} weight="fill" className="text-amber-500" />
        </div>
      </div>
      <div className="text-sm leading-snug">
        <div className="font-semibold text-amber-500 mb-1">Horario nocturno (00:00 – 08:00 hs AR)</div>
        <p className="text-foreground/90">
          Los pedidos realizados en este horario pueden demorar hasta{' '}
          <strong>6 horas</strong> en comenzar a procesarse. Se procesarán normalmente en cuanto empiece
          el turno de la mañana. ¡Gracias por tu paciencia!
        </p>
      </div>
    </div>
  );
};
